import React from 'react';
import { clsx } from 'clsx';
import { useRouter } from 'next/router';
import { useApolloClient } from '@apollo/client';
import { useSession, signOut } from 'next-auth/react';

import { Dropdown } from '@/components/common/dropdown';
import NewTransactionModal from '@/components/new-transaction-modal';
import { IconUser, IconMenu, IconX } from '@/components/icons';
import { useDialog } from '@/hooks/useDialog';
import { NavigationItem } from './components/navigation-item';

export const Header: React.FC = () => {
  const apolloClient = useApolloClient();
  const { data: session } = useSession();
  const name = 'Cambiame';
  const email = 'Cambiame@Cambiame.com';
  const router = useRouter();
  const { handleToggleVisibility, show } = useDialog();

  const onLogout = async () => {
    await signOut();
    await apolloClient.clearStore();

    router.push('/login');
  };

  return (
    <nav className="bg-white shadow">
      <div className="mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="-ml-2 mr-2 flex items-center md:hidden">
              <button
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
                aria-label="Menú"
                aria-expanded={show}
                onClick={handleToggleVisibility}
              >
                {show ? (
                  <IconX className="block h-6 w-6" title="Cerrar menú" />
                ) : (
                  <IconMenu className="block h-6 w-6" title="Abrir menú" />
                )}
              </button>
            </div>
            <div className="flex-shrink-0 flex items-center">
              <a className="text-teal-900 text-2xl font-medium" href="/">
                Stocksfolio
              </a>
            </div>
            <div className="hidden md:ml-6 md:flex">
              <NavigationItem exact name="Dashboard" link="/dashboard" type="inline" />
              <NavigationItem className="ml-2 lg:ml-8" name="Operaciones" link="/transactions" type="inline" />
              <NavigationItem className="ml-2 lg:ml-8" name="Carteras" link="/portfolios" type="inline" />
            </div>
          </div>
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <NewTransactionModal />
            </div>
            <div className="hidden md:ml-4 md:flex-shrink-0 md:flex md:items-center">
              <Dropdown
                className="p-1 border-2 border-transparent text-gray-500 rounded-full hover:text-gray-600 focus:outline-none focus:text-gray-600 focus:bg-gray-100 transition duration-150 ease-in-out"
                aria-label="Cuenta"
                toggleChildren={<IconUser title="Cuenta" className="h-6 w-6" />}
              >
                <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg">
                  <div
                    className="py-1 rounded-md bg-white ring-1 ring-black ring-opacity-5"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="user-menu"
                  >
                    {/*<a
                      href="/profile"
                      className="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                    >
                      Preferencias
                    </a>*/}
                    <button
                      onClick={onLogout}
                      className="block w-full text-left px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                    >
                      Salir
                    </button>
                  </div>
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      <div className={clsx('md:hidden', show ? 'block' : 'hidden')}>
        <div className="pt-2 pb-3">
          <NavigationItem exact name="Dashboard" link="/" type="stacked" />
          <NavigationItem name="Operaciones" link="/transactions" type="stacked" />
          <NavigationItem name="Carteras" link="/portfolios" type="stacked" />
        </div>
        <div className="pt-4 pb-3 border-t border-gray-200">
          <div className="flex items-center px-4 sm:px-6">
            <div className="flex-shrink-0">
              <img
                className="h-10 w-10 rounded-full"
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                alt=""
              />
            </div>
            <div className="ml-3">
              <div className="text-base font-medium leading-6 text-gray-800">{name}</div>
              <div className="text-sm font-medium leading-5 text-gray-500">{email}</div>
            </div>
          </div>
          <div className="mt-3">
            {/*<a
              href="/profile"
              className="mt-1 block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out sm:px-6"
            >
              Preferencias
            </a>*/}
            <button
              className="mt-1 block w-full text-left px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out sm:px-6"
              onClick={onLogout}
            >
              Salir
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};
